import { defineComponent as G, inject as J, computed as s, h as e } from "vue";
import { notificationProviderInjectionKey as L } from "./ghl-ui.es1072.js";
import { keysOf as Q } from "./ghl-ui.es944.js";
import U from "./ghl-ui.es887.js";
import { useRtl as X } from "./ghl-ui.es884.js";
import { createKey as Y } from "./ghl-ui.es739.js";
import { getMargin as Z } from "./ghl-ui.es770.js";
import { useThemeClass as oo } from "./ghl-ui.es889.js";
import { render as n } from "./ghl-ui.es1002.js";
import eo from "./ghl-ui.es894.js";
import to from "./ghl-ui.es891.js";
import io from "./ghl-ui.es897.js";
import no from "./ghl-ui.es898.js";
import so from "./ghl-ui.es896.js";
import ro from "./ghl-ui.es895.js";
const lo = {
  info: () => e(io, null),
  success: () => e(no, null),
  warning: () => e(so, null),
  error: () => e(ro, null),
  default: () => null
}, c = {
  closable: {
    type: Boolean,
    default: !0
  },
  type: {
    type: String,
    default: "default"
  },
  avatar: Function,
  title: [String, Function],
  description: [String, Function],
  content: [String, Function],
  meta: [String, Function],
  action: [String, Function],
  onClose: {
    type: Function,
    required: !0
  },
  keepAliveOnHover: Boolean,
  onMouseenter: Function,
  onMouseleave: Function
}, Ro = Q(c), So = G({
  name: "Notification",
  props: c,
  setup(t) {
    const {
      mergedClsPrefixRef: o,
      mergedThemeRef: a,
      props: d
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = J(L), { inlineThemeDisabled: r, mergedRtlRef: f } = U(), u = X("Notification", f, o), l = s(() => {
      const { type: m } = t, { self: { color: h, textColor: p, closeIconColor: v, closeIconColorHover: C, closeIconColorPressed: g, headerTextColor: b, descriptionTextColor: z, actionTextColor: x, borderRadius: y, headerFontWeight: _, boxShadow: R, lineHeight: S, fontSize: $, closeMargin: F, closeSize: I, width: w, padding: P, closeIconSize: M, closeBorderRadius: B, closeColorHover: E, closeColorPressed: T, titleFontSize: k, metaFontSize: H, descriptionFontSize: N, [Y("iconColor", m)]: A }, common: { cubicBezierEaseOut: O, cubicBezierEaseIn: V, cubicBezierEaseInOut: K } } = a.value, { left: j, right: W, top: q, bottom: D } = Z(P);
      return {
        "--n-color": h,
        "--n-font-size": $,
        "--n-text-color": p,
        "--n-description-text-color": z,
        "--n-action-text-color": x,
        "--n-title-text-color": b,
        "--n-title-font-weight": _,
        "--n-bezier": K,
        "--n-bezier-ease-out": O,
        "--n-bezier-ease-in": V,
        "--n-border-radius": y,
        "--n-box-shadow": R,
        "--n-close-border-radius": B,
        "--n-close-color-hover": E,
        "--n-close-color-pressed": T,
        "--n-close-icon-color": v,
        "--n-close-icon-color-hover": C,
        "--n-close-icon-color-pressed": g,
        "--n-line-height": S,
        "--n-icon-color": A,
        "--n-close-margin": F,
        "--n-close-size": I,
        "--n-close-icon-size": M,
        "--n-width": w,
        "--n-padding-left": j,
        "--n-padding-right": W,
        "--n-padding-top": q,
        "--n-padding-bottom": D,
        "--n-title-font-size": k,
        "--n-meta-font-size": H,
        "--n-description-font-size": N
      };
    }), i = r ? oo("notification", s(() => t.type[0]), l, d) : void 0;
    return {
      mergedClsPrefix: o,
      showAvatar: s(() => t.avatar || t.type !== "default"),
      handleCloseClick() {
        t.onClose();
      },
      rtlEnabled: u,
      cssVars: r ? void 0 : l,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    };
  },
  render() {
    var t;
    const { mergedClsPrefix: o } = this;
    return (t = this.onRender) === null || t === void 0 || t.call(this), e(
      "div",
      { class: [`${o}-notification-wrapper`, this.themeClass], onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave, style: this.cssVars },
      e(
        "div",
        { class: [
          `${o}-notification`,
          this.rtlEnabled && `${o}-notification--rtl`,
          this.themeClass,
          {
            [`${o}-notification--closable`]: this.closable,
            [`${o}-notification--show-avatar`]: this.showAvatar
          }
        ], style: this.cssVars },
        this.showAvatar ? e("div", { class: `${o}-notification__avatar` }, this.avatar ? n(this.avatar) : this.type !== "default" ? e(eo, { clsPrefix: o }, { default: () => lo[this.type]() }) : null) : null,
        this.closable ? e(to, { clsPrefix: o, class: `${o}-notification__close`, onClick: this.handleCloseClick }) : null,
        e(
          "div",
          { ref: "bodyRef", class: `${o}-notification-main` },
          this.title ? e("div", { class: `${o}-notification-main__header` }, n(this.title)) : null,
          this.description ? e("div", { class: `${o}-notification-main__description` }, n(this.description)) : null,
          this.content ? e("pre", { class: `${o}-notification-main__content` }, n(this.content)) : null,
          this.meta || this.action ? e(
            "div",
            { class: `${o}-notification-main-footer` },
            this.meta ? e("div", { class: `${o}-notification-main-footer__meta` }, n(this.meta)) : null,
            this.action ? e("div", { class: `${o}-notification-main-footer__action` }, n(this.action)) : null
          ) : null
        )
      )
    );
  }
});
export {
  So as Notification,
  Ro as notificationPropKeys,
  c as notificationProps
};
